import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";

export interface PreliminaryColorCodeFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange?: Dispatch<Array<AutocompleteData>>;
}

export const PreliminaryColorCodeFilter = ({
  value = [],
  onChange,
}: PreliminaryColorCodeFilterProps) => {
  const { t } = useTranslation();
  return (
    <ColorSearchAutocomplete
      label={t("filter_color_code_preliminary")}
      type="preliminaryColorCode"
      value={value}
      onChange={onChange}
    />
  );
};
